import { Component, Element, Host, Prop, h } from '@stencil/core';

export enum iType {
  NEUTRAL = 'neutral',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  CRITICAL = 'critical',
}

export enum iContentColor {
  NEUTRAL = 'var(--xp-ref-color-semantic-on-neutral)',
  INFO = 'var(--xp-ref-color-semantic-on-info)',
  SUCCESS = 'var(--xp-ref-color-semantic-on-success)',
  WARNING = 'var(--xp-ref-color-semantic-on-warning)',
  CRITICAL = 'var(--xp-ref-color-semantic-on-critical)',
}

export enum iBackgroundColor {
  NEUTRAL_LOW = 'var(--xp-ref-color-semantic-neutral-low-emphasis)',
  INFO_LOW = 'var(--xp-ref-color-semantic-info-low-emphasis)',
  SUCCESS_LOW = 'var(--xp-ref-color-semantic-success-low-emphasis)',
  WARNING_LOW = 'var(--xp-ref-color-semantic-warning-low-emphasis)',
  CRITICAL_LOW = 'var(--xp-ref-color-semantic-critical-low-emphasis)',
  NEUTRAL_HIGH = 'var(--xp-ref-color-semantic-neutral-high-emphasis)',
  INFO_HIGH = 'var(--xp-ref-color-semantic-info-high-emphasis)',
  SUCCESS_HIGH = 'var(--xp-ref-color-semantic-success-high-emphasis)',
  WARNING_HIGH = 'var(--xp-ref-color-semantic-warning-high-emphasis)',
  CRITICAL_HIGH = 'var(--xp-ref-color-semantic-critical-high-emphasis)',
}

export enum iEmphasis {
  LOW = 'low',
  HIGH = 'high',
}

export enum iIcon {
  INFO = 'info',
  SUCCESS = 'check_circle',
  WARNING = 'warning',
  CRITICAL = 'error',
  CLOSE = 'close',
}


@Component({
  tag: 'info-component',
  styleUrl: 'info-component.scss',
  shadow: true,
})
export class InfoComponent {
  @Prop() emphasis: iEmphasis;
  @Prop() type: iType;
  @Prop() infoHeadline?: string;
  @Prop() infoText?: string;
  @Prop() buttonLabel?: string;
  @Prop() showButton: boolean;
  @Prop() showCloseIcon: boolean;
  @Prop() showInfoHeadline: boolean;

  @Element() el: HTMLElement;
  content: HTMLElement;
  host: HTMLElement;
  button: HTMLElement;
  topLeftIcon: HTMLElement;
  topRightIcon: HTMLElement;
  headline: HTMLElement;

  initElementRefs() {
    this.content = this.el.shadowRoot.querySelector('.content') as HTMLElement;
    this.button = this.el.shadowRoot.querySelector('.button') as HTMLElement;
    this.topLeftIcon = this.el.shadowRoot.querySelector('.top-left') as HTMLElement;
    this.topRightIcon = this.el.shadowRoot.querySelector('.top-right') as HTMLElement;
    this.headline = this.el.shadowRoot.querySelector('.notification-headline') as HTMLElement;

  }

  applyTypeAndEmphasis() {
    switch (this.type) {
      case iType.NEUTRAL:
        this.emphasis == iEmphasis.HIGH ? this.el.style.backgroundColor = iBackgroundColor.NEUTRAL_HIGH : this.el.style.backgroundColor = iBackgroundColor.NEUTRAL_LOW;
        this.content.style.color = iContentColor.NEUTRAL;
        this.button.style.color = iContentColor.NEUTRAL;
        this.topLeftIcon.innerHTML = iIcon.INFO;

        break;
      case iType.INFO:
        this.emphasis === iEmphasis.HIGH ? this.el.style.backgroundColor = iBackgroundColor.INFO_HIGH : this.el.style.backgroundColor = iBackgroundColor.INFO_LOW;
        this.content.style.color = iContentColor.INFO;
        this.button.style.color = iContentColor.INFO;
        this.topLeftIcon.innerHTML = iIcon.INFO;

        break;
      case iType.SUCCESS:
        this.emphasis === iEmphasis.HIGH ? this.el.style.backgroundColor = iBackgroundColor.SUCCESS_HIGH : this.el.style.backgroundColor = iBackgroundColor.SUCCESS_LOW;
        this.content.style.color = iContentColor.SUCCESS;
        this.button.style.color = iContentColor.SUCCESS;
        this.topLeftIcon.innerHTML = iIcon.SUCCESS;

        break;
      case iType.WARNING:
        this.emphasis === iEmphasis.HIGH ? this.el.style.backgroundColor = iBackgroundColor.WARNING_HIGH : this.el.style.backgroundColor = iBackgroundColor.WARNING_LOW;
        this.content.style.color = iContentColor.WARNING;
        this.button.style.color = iContentColor.WARNING;
        this.topLeftIcon.innerHTML = iIcon.WARNING;

        break;
      case iType.CRITICAL:
        this.emphasis === iEmphasis.HIGH ? this.el.style.backgroundColor = iBackgroundColor.CRITICAL_HIGH : this.el.style.backgroundColor = iBackgroundColor.CRITICAL_LOW;
        this.content.style.color = iContentColor.CRITICAL;
        this.button.style.color = iContentColor.CRITICAL;
        this.topLeftIcon.innerHTML = iIcon.CRITICAL;

        break;
    }
  }

  checkButtonVisibility() {
    this.showButton ? this.button.style.display = 'block' : this.button.style.display = 'none';
    this.showCloseIcon ? this.topRightIcon.style.display = 'block' : this.topRightIcon.style.display = 'none';
    this.showInfoHeadline ? this.headline.style.display = 'block' : this.headline.style.display = 'none';
  }

  componentDidLoad() {
    this.initElementRefs();
    this.applyTypeAndEmphasis();
    this.checkButtonVisibility();
  }

  hideInfo() {
    this.el.style.display = 'none';
  }


  render() {
    return (
      <Host>
        <div class="content">
          <i class="material-icons top-left"></i>
          <div class="text">
            <div class="notification-headline">{this.infoHeadline}</div>
            <div class="notification-text">{this.infoText}</div>
            <button class="button">{this.buttonLabel}</button>
          </div>
          <i class="material-icons top-right" onClick={() => this.hideInfo()}>close</i>
        </div>
      </Host>
    );
  }
}
